import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getMultilingualOptInEnabledSelector,
  setOptInPropertyMultilingualEnabledSelector,
  useNautilusSelector,
  type MultilingualizableConfigValue,
} from "../state/index.ts";

type Setter = {
  // We make initialValue required because the consumer model must knowingly support null rather than the framework shoving it in.
  (optIn: true, initialValue: MultilingualizableConfigValue): void;
  (optIn: false): void;
};

type ReturnValue = [boolean, Setter];

export const useMultilingualOptIn = (id: number, property: string): ReturnValue => {
  const dispatch = useDispatch();
  const getMultilingualOptInEnabled = useSelector(getMultilingualOptInEnabledSelector);
  const setPropertyMultilingual = useNautilusSelector((state) =>
    setOptInPropertyMultilingualEnabledSelector(state, { dispatch }),
  );
  return useMemo(() => {
    const on = getMultilingualOptInEnabled(id, property);
    const setter: Setter = (optIn, initialValue?) => {
      if (optIn) {
        setPropertyMultilingual(id, property, {
          optIn: true,
          initialValue: initialValue as MultilingualizableConfigValue,
        });
      } else {
        setPropertyMultilingual(id, property, { optIn: false });
      }
    };
    return [on, setter];
  }, [getMultilingualOptInEnabled, id, property, setPropertyMultilingual]);
};
